
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"data-name":"Instructor Icon","width":"24","height":"24","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACVUlEQVRIiZ2WTUhVURDHf10rwR7RIqOCtMhFHy5aFAXRQpCWQiJlEVGL1tYiCltIqzLtc+0yzbQi3Ig9SDFaVFuDoC+toKgWgrnpwxcj//u4XuYczIHHuWfOf/5zzpw5M29ZsVgkIjXAMaAB2AFUA7+Bz8AUMAbcAz6EKEIOjPgKcBioiO0AmJOTC8DH/GLiGDQBE8BR4C9wHzgObAEqgdXAduls7Y+wrzQukOW5eRtwXY4fAeeAtznML+C1fr1AHXAVOKT5euCGd4IjWigB52WQJ/fEMM2ysXBdE9cCBxbzHrsToF07yspewC7rJzADjEiXFbO5KI4ecZYdXAYKwEOHfA8wDjQCq4Q7KN3uHLYTeCBMZ+qgFmhVbM84IbgErHT0putw9GfFZRlYm4g8UUZ8cgz2R+K/z9EZx6A4WxM9IpQ1nni7T6UyoE+5GsxBvSYvAuCpiIPJgP6lxnpzsFaTrwHwWMTBeED/RWN19h3MBcC9EQd3A/ryAzYHP/S9MQB+Ggjfc+BZwGaDxu+JaghOTmflpqO7HcHv0jhhDp5o0hIxKDi6qgi+WeOolevNwDvdQV0ma+zVHlBdOeFUXusLd4ABhXFW+k3AG2AFsDVRqg3oYrqAbcBjYBoYBk4GyroRnBJmWjbWlLr1PoxzMm04NbqLgsBrIsePSWprRXGnNaB0Z9aJTqtUL5Uc2ZbENd/dskfvV6EKvYfFSElNqj/F5mN7S41mZgnkFhZro9ZwyuJd3pDqk+1iMacxjGEt5n35xf/522IE66T/pqQYVba8d62Bf88Jh2RifoOHAAAAAElFTkSuQmCC"}})])
          )
        }
      }
    